import { render, staticRenderFns } from "./PromotionReview.vue?vue&type=template&id=279ff8a6&"
import script from "./PromotionReview.vue?vue&type=script&lang=js&"
export * from "./PromotionReview.vue?vue&type=script&lang=js&"
import style0 from "./PromotionReview.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PromotionReview.vue"
export default component.exports